import React from 'react';
import Devices from '../DevicesTable';

function UserDetails({ id, storeId }) {
  return <Devices query={{ user_id: id, storeId }} />;
}

export default UserDetails;
